import { colorsPalettes } from "@similarweb/styles";
import { EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { TopicsDiscoverTrendCard } from "./TopicsDiscoverTrendCard";
import { TopicsDiscoverTrendCardsSkeleton } from "./TopicsDiscoverTrendCardsSkeleton";
import type { TrendingTopicsData } from "./types";

type TopicsDiscoverTrendingSectionProps = {
    data: TrendingTopicsData | undefined;
    isError: boolean;
    isLoading: boolean;
};

export const TopicsDiscoverTrendingSection = ({ data, isError, isLoading }: TopicsDiscoverTrendingSectionProps) => {
    const t = useTranslation();
    const discoverCategory = data?.topic?.path ?? "general";

    if (isError) {
        return (
            <Flex
                height="244px"
                justifyContent="center"
                alignItems="center"
                background={colorsPalettes.sky[100]}
            >
                <EmptyState
                    title={t("demand.analysis.home.discover.error.title")}
                    subtitle={t("demand.analysis.home.discover.error.subtitle")}
                />
            </Flex>
        );
    }

    return (
        <Flex
            padding="8px"
            gap="8px"
            width="100%"
            background={colorsPalettes.sky[100]}
            borderRadius="6px"
        >
            {isLoading ? (
                <TopicsDiscoverTrendCardsSkeleton />
            ) : (
                data?.topics?.map((topic) => (
                    <TopicsDiscoverTrendCard
                        key={`${topic.name}-${topic.identifier.type}`}
                        topic={topic}
                        discoverCategory={discoverCategory}
                    />
                ))
            )}
        </Flex>
    );
};
